import { Injectable } from '@angular/core';
import {
  allComponents,
  provideFluentDesignSystem
} from '@fluentui/web-components';

/**
 * Service for initializing and managing Fluent UI Web Components
 * This enables smooth integration with Fluent UI components in Angular
 */
@Injectable({
  providedIn: 'root'
})
export class FluentUIService {

  constructor() {
    this.initializeFluent();
  }

  /**
   * Initialize Fluent Design System and register all components
   */
  private initializeFluent(): void {
    try {
      // Provide Fluent Design System globally with all available components
      provideFluentDesignSystem().register(allComponents);
    } catch (error) {
      console.warn('Fluent UI initialization note:', error);
    }
  }
}
